export default __webpack_public_path__ + "static/media/checkmark.773de809.svg";